module.exports = __webpack_public_path__ + "images/feature/20151225_02-cadacc6ebbb85c8dc9942885e1adfdae.png";